/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Sources_Collapse_FilesInputs */

const es_components_sources_collapse_files = /** @type {(inputs: Components_Sources_Collapse_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar Archivos`)
};

const en_components_sources_collapse_files = /** @type {(inputs: Components_Sources_Collapse_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide Files`)
};

/**
* | output |
* | --- |
* | "Hide Files" |
*
* @param {Components_Sources_Collapse_FilesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_sources_collapse_files = /** @type {((inputs?: Components_Sources_Collapse_FilesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Sources_Collapse_FilesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_sources_collapse_files(inputs)
	return en_components_sources_collapse_files(inputs)
});
export { components_sources_collapse_files as "components.sources.collapse_files" }